import { forwardRef } from 'react'
import type { ButtonHTMLAttributes } from 'react'

export type PressableProps = ButtonHTMLAttributes<HTMLButtonElement>

export const Pressable = forwardRef<HTMLButtonElement, PressableProps>(function Pressable(
  {
    type = 'button',
    className,
    children,
    ...rest
  },
  ref,
) {
  const classes = ['pressable', className].filter(Boolean).join(' ')

  return (
    <button
      ref={ref}
      type={type}
      className={classes}
      {...rest}
    >
      {children}
    </button>
  )
})
